const { getElement, getOffsetLeft, getOffsetTop } = window.BAO.Utils

class ProductMedia extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: block;
      }
    `
  }

  static get requiredElements () {
    return ['thumbnails', 'thumbnail', 'medias', 'media']
  }

  setupListeners () {
    super.setupListeners()

    this.onThumbnailClick = this.onThumbnailClick.bind(this)
    this.onImageHover = this.onImageHover.bind(this)

    this.listeners.add(
      this.els.thumbnails.element,
      'click',
      this.onThumbnailClick,
    )
    this.listeners.add(this.els.medias.element, 'mousemove', this.onImageHover)

    this.observeItems()
  }

  onThumbnailClick (event) {
    const thumbnail = event.target.closest(this.els.thumbnail.selector)
    if (!thumbnail) return

    const media = this.els.media.elements.find(
      el => thumbnail.dataset.thumbnail === el.dataset.item,
    )
    if (!media) return

    window.BAO.Utils.scrollToY(getOffsetTop(media) - this.anchorOffset)
  }

  onImageHover (event) {
    const media = event.target.closest(this.els.media.selector)
    if (!media) return

    const imageZoomElement = getElement('.rsp-Image', {
      context: media,
    })
    if (!imageZoomElement) return

    imageZoomElement.style.transformOrigin = `${event.pageX -
      getOffsetLeft(media)}px ${event.pageY - getOffsetTop(media)}px`
  }

  observeItems () {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 1,
    }

    function observerCallback (entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const thumbnailItem = Array.from(
            document.querySelectorAll('[data-product-media-el="thumbnail"]'),
          ).find(el => el.dataset.thumbnail === entry.target.dataset.item)

          thumbnailItem.setAttribute('aria-current', true)
          document
            .querySelectorAll('[data-product-media-el="thumbnail"]')
            .forEach(item => {
              if (item !== thumbnailItem) {
                item.setAttribute('aria-current', false)
              }
            })
        }
      })
    }

    // eslint-disable-next-line compat/compat
    const observer = new IntersectionObserver(observerCallback, observerOptions)

    this.els.media.elements.forEach(media => observer.observe(media))
  }

  get anchorOffset () {
    const headerHeight =
      document.querySelector('[data-section-type="header"]')?.offsetHeight ?? 0
    const gap = 20

    return headerHeight + gap
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
